import React from 'react';
import { createRoot } from 'react-dom/client';  // Utiliser createRoot
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Récupère l'élément de base pour l'application
const rootElement = document.getElementById('root');

// Crée le root en utilisant la nouvelle API
const root = createRoot(rootElement);

// Rend l'application avec createRoot
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);